module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Font-49fa802033c5a38ee2714ad664dc7091.svg";